import { render, staticRenderFns } from "./FinalPaymentModal.vue?vue&type=template&id=1f955b60&scoped=true&"
import script from "./FinalPaymentModal.vue?vue&type=script&lang=js&"
export * from "./FinalPaymentModal.vue?vue&type=script&lang=js&"
import style0 from "./FinalPaymentModal.vue?vue&type=style&index=0&id=1f955b60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f955b60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f955b60')) {
      api.createRecord('1f955b60', component.options)
    } else {
      api.reload('1f955b60', component.options)
    }
    module.hot.accept("./FinalPaymentModal.vue?vue&type=template&id=1f955b60&scoped=true&", function () {
      api.rerender('1f955b60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/projects/submission-request/FinalPaymentModal.vue"
export default component.exports